export default "__VITE_ASSET__f7224526__"